export default __webpack_public_path__ + "static/media/drms-1.336e1096.gif";